import { Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './restaurant/contexts/AuthContext';
import RestaurantLayout from './restaurant/layouts/RestaurantLayout';
import OrdersPage from './restaurant/pages/OrdersPage';
import OrderDetailPage from './restaurant/pages/OrderDetailPage';
import OrderReceiptPage from './restaurant/pages/OrderReceiptPage';
import MenuPage from './restaurant/pages/MenuPage';
import MenuItemEditPage from './restaurant/pages/MenuItemEditPage';
import AnalyticsPage from './restaurant/pages/AnalyticsPage';
import EarningsPage from './restaurant/pages/EarningsPage';
import PaymentsPage from './restaurant/pages/PaymentsPage';
import NotificationsPage from './restaurant/pages/NotificationsPage';
import ProfilePage from './restaurant/pages/ProfilePage';
import WelcomePage from './restaurant/pages/WelcomePage';

// Mounted at /business/* in the host app router.
export default function RestaurantPortal() {
  return (
    <AuthProvider>
      <Routes>
        <Route element={<RestaurantLayout />}>
          <Route index element={<Navigate to="orders" replace />} />
          <Route path="orders" element={<OrdersPage />} />
          <Route path="orders/:orderId" element={<OrderDetailPage />} />
          <Route path="orders/:orderId/receipt" element={<OrderReceiptPage />} />
          <Route path="menu" element={<MenuPage />} />
          <Route path="menu/new" element={<MenuItemEditPage />} />
          <Route path="menu/:itemId" element={<MenuItemEditPage />} />
          <Route path="analytics" element={<AnalyticsPage />} />
          <Route path="earnings" element={<EarningsPage />} />
          <Route path="payments" element={<PaymentsPage />} />
          <Route path="notifications" element={<NotificationsPage />} />
          <Route path="profile" element={<ProfilePage />} />
          <Route path="welcome" element={<WelcomePage />} />
        </Route>
        <Route path="*" element={<Navigate to="orders" replace />} />
      </Routes>
    </AuthProvider>
  );
}
